import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
// import { parseText } from "./parseText";

const urlBase = `${process.env.API_URL}/relevoDePerfil`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const getRelevosDePerfil = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  const clientId = query.get("clientId");

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");
  query.delete("clientId");

  let res = await fetch(readUrl(`/all/${clientId}?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getRelevoDePerfilById = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createRelevoDePerfil = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const updateRelevoDePerfil = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  res = await parseJSON(res);
  return res.success;
};

export const relevoDePerfilCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/category`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const generatePDFRelevosDePerfilFromTemplate = async (relevoId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/pdf/${relevoId}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};
